import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `
.custom-overlay {
  background: ${dt('select.overlay.background')};
  color: ${dt('select.overlay.color')};
  border: 1px solid ${dt('select.overlay.border.color')};
  border-radius: ${dt('select.overlay.border.radius')};
}
`;
